import React                from "react"
import {useHistory}         from "react-router"

import {IonCol, IonGrid, IonList, IonRow, IonAccordionGroup} from "@ionic/react"

import {User     as ItemType}     from "../../types/User"
import {useUsers as useItems} from "../../contexts/UserContext"
import {useAuth}              from "../../contexts/AuthContext"

import FormAccordionAccount  from "./Form/AccordionAccount"
import FormAccordionLimits   from "./Form/AccordionLimits"
import FormAccordionUser     from "./Form/AccordionUser"
import FormAccordionLinkLockingSystemPermissions from "../common/Form/Accordions/LinkLockingSystemPermissions";

import FormButtonSaveChanges from "../common/Buttons/FormButtonSaveChanges"
import FormButtonSaveNew     from "../common/Buttons/FormButtonSaveNew"

interface formProps {
    item: ItemType | undefined
}

const Form: React.FC<formProps> = ({ item }) => {

    const { addItem, editItem, message } = useItems()
    const { userInfo: authUserInfo } = useAuth()
    const history       = useHistory()

    const
        accordionGroupRef = React.useRef<null | HTMLIonAccordionGroupElement>(null),
        [linkLockingSystemPermissionIds, setLinkLockingSystemPermissionIds] = React.useState<number[]>([])

    const initialFormData: ItemType = {
        id:                  item?.id          || 0,
        isEnabled:           item ? item.isEnabled : true,
        isAdmin:             item ? item.isAdmin   : false,
        maxKeys:             item?.maxKeys     || 0,
        maxUsers:            item?.maxUsers    || 0,
        name:                item?.name        || '',
        email:               item?.email       || '',
        password:            item?.password    || '',
        account: {
            id: authUserInfo?.account.id || 0
        }
    }

    const [formData, setFormData] = React.useState(initialFormData)

    const updateFormHandler = React.useCallback((type: any) => (event: any) => {
        setFormData({ ...formData, [type]: event.target.value })
    }, [formData])

    React.useEffect(() => {
        setFormData(initialFormData)
        if (! accordionGroupRef.current) return

        accordionGroupRef.current.value = ['account', 'limits', 'user', 'link_locking_system_permissions', ]
    }, [item])

    const handleSave = async (e: any) => {
        e.preventDefault()
        e.stopPropagation()

        if (item && item.id) {
            const result = await editItem(formData)

            if (result !== undefined || message !== undefined) {
                if (result) window.location.href = '/users/' + formData.id + '/view'
            }
        } else {
            const newItem: ItemType = {...formData, lockingSystemPermissions: null}

            if (formData.isAdmin === false && linkLockingSystemPermissionIds.length > 0) {
                newItem.lockingSystemPermissions = linkLockingSystemPermissionIds?.map(
                    (lspId) => { return {id: lspId} })
            }

            const newUser = await addItem(newItem)

            if (newUser) {
                setFormData(initialFormData)

                history.push('/users/' + newUser.id + '/view')
            }
        }
    }

    const FormKeyUp = (e: any) => {
        if (e.key === 'Enter') handleSave(e);
    }

    return (
        <IonList className="maxWidth">
        <form autoComplete="off"
              method="POST"
              id="formUser"
              onSubmit={handleSave}
              onKeyUp={e => FormKeyUp(e)}>

            <IonAccordionGroup multiple={true} ref={accordionGroupRef}>
                {! item &&
                    <FormAccordionAccount formData={formData} setFormData={setFormData}
                                          account={authUserInfo?.account} updateFormHandler={updateFormHandler} />
                }
                <FormAccordionUser authUserInfo={authUserInfo} formData={formData}
                                   setFormData={setFormData} updateFormHandler={updateFormHandler} />
                {! formData.isAdmin && formData.id !== authUserInfo?.user.id &&
                    <FormAccordionLimits authUserInfo={authUserInfo} formData={formData}
                                         item={item} updateFormHandler={updateFormHandler} />
                }
                {! item && ! formData.isAdmin &&
                    <FormAccordionLinkLockingSystemPermissions
                        linkLockingSystemPermissionIds={linkLockingSystemPermissionIds}
                        setLinkLockingSystemPermissionIds={setLinkLockingSystemPermissionIds} />
                }
            </IonAccordionGroup>

            <IonGrid className="ion-margin-top">
                <IonRow>
                    <IonCol className="ion-text-right">
                        {item?.id ? <FormButtonSaveChanges/> : <FormButtonSaveNew/>}
                    </IonCol>
                </IonRow>
            </IonGrid>

        </form>
        </IonList>
    )

}

export default Form